import { computed } from '@angular/core';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { accountexternal, entities } from 'src/shared/services/client/client';

/**
 * No-op UserStore for trialsClinic. Does not make GetMyUser or ListPets API requests.
 * trialsClinic uses ClinicProfileStore for clinician data and route params for participant data.
 */
const initialState = {
  user: null as accountexternal.GetUserResponse | null,
  pets: [] as entities.PetResponse[],
  activePet: null as entities.PetResponse | null,
  loggedIn: false,
  loading: false,
  onboarding: false,
  userError: undefined as any,
  petError: undefined as any,
  initalLoad: true,
};

export const NoopUserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ user }) => ({
    userID: computed(() => user()?.doc_id || null),
  })),
  withMethods(() => ({
    setActivePet: () => {},
    setActivePetById: () => {},
    refreshUser: () => {},
    refreshPets: () => {},
    setUserAndPets: () => {},
  }))
);
